import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormatoPdfFichaTecnicaComponent } from '../formato-pdf-ficha-tecnica/formato-pdf-ficha-tecnica.component';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PdfUtils } from 'src/app/shared/utils/pdf-utils';
import { PptxUtils } from 'src/app/shared/utils/pptx-utils';
import { ObraDTO } from 'src/app/models/dtos/obra-dto';
import { Obra } from 'src/app/models/entities/obra';

@Component({
  selector: 'modal-nota-informativa',
  templateUrl: './modal-nota-informativa.component.html',
  styleUrls: ['./modal-nota-informativa.component.scss']
})
export class ModalNotaInformativaComponent implements OnInit {

  public obraSeleccionada: ObraDTO;

  @ViewChild('modalFichaTecnica')
  public modalFichaTecnica: any;

  public modalActivo: NgbModalRef;

  @Input('mostrarBtnGuardarFormato')
  public mostrarBtnGuardarFormato: boolean = false;

  @Output()
  public guardarFormatoListener: EventEmitter<ObraDTO> = new EventEmitter<ObraDTO>();

  constructor(private modalService: NgbModal, private pdfUtils: PdfUtils, private pptxUtils: PptxUtils) { }

  public ngOnInit(): void {
  }
  public abrirModal(obra: ObraDTO): void {
    this.obraSeleccionada = obra;
    this.modalActivo = this.modalService.open(this.modalFichaTecnica, { centered: true, size: 'lg', windowClass: 'modal-ficha-tecnica' });
  }

  public abrirModalPersonalizado(obra: Obra, nombreTramoLicitacion: string, nombreObra: string, nombreEstado: string, keyDireccionAdjunta: string): void {
    let datosObra: ObraDTO = new ObraDTO();
    datosObra.obra = obra;
    datosObra.nombreTramoLicitacion = nombreTramoLicitacion;
    datosObra.nombreObra = nombreObra;
    datosObra.nombreEstado = nombreEstado;
    datosObra.keyCatDireccionAdjunta = keyDireccionAdjunta;
    this.obraSeleccionada = datosObra;
    this.modalActivo = this.modalService.open(this.modalFichaTecnica, { centered: true, size: 'lg', windowClass: 'modal-ficha-tecnica' });
  }

  public descargar(): void {
    this.pdfUtils.descargarNotaInformativa();
  }

  public descargarPPTXNotaInformativa() {
    this.pptxUtils.descargarPowerPointNotaInformativa(this.obraSeleccionada);
  }

  public guardarFormato(): void {
    this.guardarFormatoListener.emit(this.obraSeleccionada);
  }

  public cerrarModal(): void {
    this.modalActivo.close();
  }

}